import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Tenant } from '@app/Models/tenant';
import { TenantService } from '@app/Services';
import { TenantEnvironmentService } from '@app/Services/tenant-environment.service';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export const tenantResolver: ResolveFn<Tenant | null> = (route) => {
  const tenantService = inject(TenantService);
  const tenantEnvService = inject(TenantEnvironmentService);
  const router = inject(Router);
  const tenantId = route.paramMap.get('tenantId');

  if (
    tenantService.selectedTenant?.TenantId === tenantId &&
    tenantService.selectedTenant?.Value !== '-1'
  ) {
      return of(tenantService.selectedTenant);
  }

  return tenantService.loadTenants().pipe(
    map((tenants) => {
      const tenant = tenants.find((t) => t.TenantId === tenantId);
      if (!tenant?.HasAccess) {
          router.navigate(['/']);
          return null;
      }
      // Reset organisationId to null BEFORE selectedTenant emits, so identifyTenant's
      // filter(id => id !== null) blocks until the new tenant's org ID arrives.
      tenantService.resetOrganisationId();
      tenantService.selectedTenant = tenant;
      tenantService.loadTenantMetadata(tenant.Value);
      tenantEnvService.getEnvironmentDetailsForCurrentTenant(tenant.Value);
      return tenant;
    })
  );
};
